<ng-container *ngIf="lists">
    <div id="" class="most-popular">
        <div *ngFor="let list of lists">
            <figure class="col">
                <a class="position-relative d-block youtube w-100 h-100"
                    [routerLink]="['/pooja/poojadetails/' , list.pujaId]" [queryParams]="{name: list.pujaName}">
                <img [src]="list.pujaImage || 'https://media.istockphoto.com/photos/closeup-of-indian-hindu-goddess-lakshmi-idol-in-a-temple-picture-id1224777525?s=2048x2048'"
                    class="d-block w-100 img-fluid ceremony mb-3" alt="...">
                <figcaption>
                    <p class="mb-0 text-truncate col-10 p-0"><strong>{{list.pujaName}}</strong></p>
                    <!-- <p class="truncate-overflow">{{list.pujaDescription}}</p> -->
                </figcaption>
                </a>
            </figure>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="shekTvlists">
    <div id="" class="reviews">
        <div *ngFor="let list of shekTvlists">
            <figure class="col">
                <a class="position-relative d-block youtube w-100 h-100" data-fancybox
                    href="https://www.youtube.com/watch?v={{list.url}}?autoplay=1">
                    <span class="material-icons-outlined font-38 position-absolute play">
                        play_circle_filled
                    </span>
                    <img [src]=" 'http://i3.ytimg.com/vi/' + list.url +'/0.jpg' || 'https://media.istockphoto.com/photos/closeup-of-indian-hindu-goddess-lakshmi-idol-in-a-temple-picture-id1224777525?s=2048x2048'"
                        class="img-fluid mb-3 border-radius" alt="...">
                </a>
                <figcaption>
                    <p class="mb-0 text-truncate col-10 p-0"><strong>{{list.title}}</strong></p>
                    <p class="truncate-overflow">{{list.description}}</p>
                </figcaption>
            </figure>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="homePagelists">
    <div id="" class="reviews">
        <div *ngFor="let list of homePagelists">
            <figure class="col">
                <a class="position-relative d-block youtube w-100 h-100" data-fancybox
                    href="https://www.youtube.com/watch?v={{list.url}}?autoplay=1">
                    <span class="material-icons-outlined font-38 position-absolute play">
                        play_circle_filled
                    </span>
                    <img [src]=" 'http://i3.ytimg.com/vi/' + list.url +'/0.jpg' || 'https://media.istockphoto.com/photos/closeup-of-indian-hindu-goddess-lakshmi-idol-in-a-temple-picture-id1224777525?s=2048x2048'"
                        class="img-fluid mb-3 border-radius" alt="...">
                </a>
                <figcaption>
                    <p class="mb-0 text-truncate col-10 p-0"><strong>{{list.title}}</strong></p>
                    <p class="truncate-overflow">{{list.description}}</p>
                </figcaption>
            </figure>
        </div>
    </div>
</ng-container>


<ng-container *ngIf="astrologylists">
    <div id="" class="astro-listing mb-3">
        <div>
            <div class="col-12 mb-2 text-center">
                <button type="button" class="btn btn-clear regular p-0">
                    <img src="https://images.pexels.com/photos/5720902/pexels-photo-5720902.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                        alt="..." class="img-fluid pic rounded-circle">
                </button>
            </div>
            <div class="col-12 text-center">
                <h3 class="font-22 bold mb-0">Nirmal Baba</h3>
                <p class="rating font-16 mb-1">
                    <span class="star txt-warning ic-" aria-hidden="true">star</span> 4.3
                </p>
                <p class="mb-1 exp txt-muted font-16">8+ years | <span class="txt-warning"><span
                            class="rate font-12 ic-">rupee</span> 350</span> </p>
                <button type="button" class="btn btn-primary">Book Now</button>

            </div>
        </div>
    </div>
</ng-container>


<!-- <a data-fancybox href="https://www.youtube.com/watch?v=_sI_Ps7JSEk">
    YouTube video
</a> -->
